import { useTranslation } from "../i18n";
import SuppliersAdmin from "../components/SuppliersAdmin";
import AdminPageHeader from "../components/admin-page-header";
import "../styles/admin-settings.css";

const AdminSuppliers = () => {
    const { t } = useTranslation();
    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="suppliers_settings"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "suppliers_settings" },
                ]}
            />
            <div className="admin-settings-section">
                <p className="admin-settings-section-hint">{t("suppliers_settings_hint")}</p>
                <SuppliersAdmin />
            </div>
        </div>
    );
};

export default AdminSuppliers;
